module.exports = __webpack_public_path__ + "img/index-7.c2c7a30d.png";